import React, { useState, useEffect } from "react";

const SubscriptionForm = ({ initialData, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({
        name: "",
        actualPrice: "",
        discountPrice: "",
        discountPercentage: "",
        prefix: "",
        period: "",
        subtext: "",
        limit: "",
        features: [],
        recommended: false,
        dietaryType: "veg",
    });

    const [newFeature, setNewFeature] = useState("");

    useEffect(() => {
        if (initialData) {
            setFormData({ dietaryType: "veg", ...initialData });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleAddFeature = () => {
        if (newFeature.trim() !== "") {
            setFormData((prev) => ({
                ...prev,
                features: [...prev.features, newFeature.trim()],
            }));
            setNewFeature("");
        }
    };

    const handleRemoveFeature = (indexToRemove) => {
        setFormData((prev) => ({
            ...prev,
            features: prev.features.filter((_, index) => index !== indexToRemove),
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-md mb-6">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">
                {initialData ? "Edit Subscription" : "Add New Subscription"}
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Subscription Name *
                        </label>
                        <input
                            type="text"
                            name="name"
                            required
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                            placeholder="e.g., Slim & Fit"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Prefix
                        </label>
                        <input
                            type="text"
                            name="prefix"
                            value={formData.prefix}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                            placeholder="e.g., Starting at"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Actual Price (₹) *
                        </label>
                        <input
                            type="text"
                            name="actualPrice"
                            required
                            value={formData.actualPrice}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Discount Price (₹)
                        </label>
                        <input
                            type="text"
                            name="discountPrice"
                            value={formData.discountPrice}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Discount Percentage (%)
                        </label>
                        <input
                            type="text"
                            name="discountPercentage"
                            value={formData.discountPercentage}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                            placeholder="e.g., 5"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Period
                        </label>
                        <input
                            type="text"
                            name="period"
                            value={formData.period}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                            placeholder="e.g., /month, /week"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Subtext
                        </label>
                        <input
                            type="text"
                            name="subtext"
                            value={formData.subtext}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                            placeholder="e.g., Billed monthly"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Limit
                        </label>
                        <input
                            type="text"
                            name="limit"
                            value={formData.limit}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                            placeholder="e.g., 2 Meals / Day"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Dietary Type
                        </label>
                        <div className="flex rounded-lg border overflow-hidden w-fit">
                            {[
                                { value: "veg", label: "🌱 Veg", active: "bg-green-600" },
                                { value: "non-veg", label: "🍖 Non-Veg", active: "bg-red-600" },
                            ].map((opt) => (
                                <button
                                    key={opt.value}
                                    type="button"
                                    onClick={() =>
                                        setFormData((prev) => ({ ...prev, dietaryType: opt.value }))
                                    }
                                    className={`px-4 py-2 text-sm font-medium transition ${formData.dietaryType === opt.value
                                        ? `${opt.active} text-white`
                                        : "bg-white text-gray-700 hover:bg-gray-50"
                                        }`}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="flex items-center mt-6">
                        <input
                            type="checkbox"
                            id="recommended"
                            name="recommended"
                            checked={formData.recommended}
                            onChange={handleChange}
                            className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                        />
                        <label
                            htmlFor="recommended"
                            className="ml-2 block text-sm text-gray-900"
                        >
                            Mark as Recommended
                        </label>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Features List
                    </label>
                    <div className="flex space-x-2 mb-2">
                        <input
                            type="text"
                            value={newFeature}
                            onChange={(e) => setNewFeature(e.target.value)}
                            className="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                            placeholder="Add a new feature..."
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleAddFeature();
                                }
                            }}
                        />
                        <button
                            type="button"
                            onClick={handleAddFeature}
                            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                        >
                            Add
                        </button>
                    </div>

                    <ul className="space-y-2 mt-2">
                        {formData.features.map((feature, index) => (
                            <li
                                key={index}
                                className="flex justify-between items-center bg-gray-50 px-3 py-2 rounded-lg border"
                            >
                                <span className="text-gray-700">{feature}</span>
                                <button
                                    type="button"
                                    onClick={() => handleRemoveFeature(index)}
                                    className="text-red-500 hover:text-red-700 text-sm font-medium"
                                >
                                    Remove
                                </button>
                            </li>
                        ))}
                        {formData.features.length === 0 && (
                            <li className="text-gray-400 text-sm py-2">No features added yet.</li>
                        )}
                    </ul>
                </div>

                <div className="flex justify-end space-x-4 pt-4 border-t">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                    >
                        {initialData ? "Update Subscription" : "Save Subscription"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SubscriptionForm;
